import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtUser } from "server/models"
import { deepCopy, StateType } from "client/utils"
import {
    StoreType,
    AccountProps,
    UserList,
    UserFilters,

    ChangeUserStatus,
    SortUsers,
    AddAccountUser,

    closeModal,
    setUserList,
    setNotAssignedAccountUserIds,
    setNotAssignedAccountUserSort,
    setNotAssignedAccountUserFilters,
    setNotAssignedAccountUserSelected,
    setAccountUserReloadList,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    ChangeStatus,
    SpinnerIcon,
} from "client/components"

import UserSearch from "client/pages/search/userSearch"
import Columns from "./columns"

let isMounted: boolean

const NotAssignedUsers = ({
    accountId = null,
}: AccountProps) => {
    const packageList = useSelector((state: StoreType) => state.package.packageList)
    const accountPackageList = useSelector((state: StoreType) => state.accountPackage.accountPackageList)

    const userList = useSelector((state: StoreType) => state.user.userList)
    const accountUserList = useSelector((state: StoreType) => state.accountUser.accountUserList)

    const userIds = useSelector((state: StoreType) => state.accountUser.notAssignedUsers.userIds)
    const sortColumn = useSelector((state: StoreType) => state.accountUser.notAssignedUsers.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.accountUser.notAssignedUsers.sortOrder)
    const filters = useSelector((state: StoreType) => state.accountUser.notAssignedUsers.filters)
    const selected = useSelector((state: StoreType) => state.accountUser.notAssignedUsers.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedUserIds = SortUsers(Object.values(userList), sortColumn, sortOrder, filters)
        const accountUserIds = accountUserList && accountUserList[accountId] ? accountUserList[accountId] : []

        const sortedNotAssigned = sortedUserIds.filter((userId) => !accountUserIds.includes(userId))
        dispatch(setNotAssignedAccountUserIds(sortedNotAssigned))
    }, [accountUserList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtUser, order) => {
        dispatch(setNotAssignedAccountUserSort(column, order))
    }

    const onFilter = (newFilters: UserFilters) => {
        dispatch(setNotAssignedAccountUserFilters(newFilters))
        dispatch(setNotAssignedAccountUserSelected(null))
    }

    const onStatusChange: ChangeStatus = (user: MtUser, callback) => {
        ChangeUserStatus(user).then((status) => {
            callback(() => {
                const userListCopy: UserList = deepCopy(userList)
                userListCopy[user.id] = {
                    ...userListCopy[user.id],
                    status,
                }
                dispatch(setUserList(userListCopy))
            })
        })
    }

    const addAccountUsers = () => {
        setSaveState(PENDING)

        // define max users
        const packageId = accountPackageList && accountPackageList[accountId] && accountPackageList[accountId].length
            ? accountPackageList[accountId][0].packageId
            : null
        const activePackage = packageList ? packageList[packageId] : null
        const maxUsers = activePackage ? activePackage.maxUsers : null

        AddAccountUser(selected, accountId, maxUsers).then(() => {
            if (isMounted) {
                setSaveState(IDLE)
                dispatch(closeModal())
            }
            dispatch(setNotAssignedAccountUserSelected(null))

            dispatch(setAccountUserReloadList(false))
            setTimeout(() => {
                dispatch(setAccountUserReloadList(true))
            }, 0)
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectUser_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <UserSearch
                        id="notAssignedAccountUsers"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={userList}
                    dataIds={userIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                    onStatusChange={onStatusChange}
                />
                <PageForm>
                    <Button variant="success" onClick={addAccountUsers}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotAssignedUsers
